(() => {
  if (window.__COSTA_CART_ADDONS_INIT__) return;
  window.__COSTA_CART_ADDONS_INIT__ = true;

  const lock = new Map(); // variantId -> boolean

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('Failed to fetch cart');
    return r.json();
  }

  function findLineItemKey(cart, variantId) {
    const item = cart.items.find(i => Number(i.variant_id) === Number(variantId));
    return item ? item.key : null;
  }

  async function addVariant(variantId, quantity = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity })
    });

    if (!r.ok) {
      let err = {};
      try { err = await r.json(); } catch (e) {}
      throw new Error('Add failed ' + r.status + ' ' + (err.errors || ''));
    }

    return r.json();
  }

  async function changeLineItem(key, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });

    if (!r.ok) {
      let err = {};
      try { err = await r.json(); } catch (e) {}
      throw new Error('Change failed ' + r.status + ' ' + (err.errors || ''));
    }

    return r.json();
  }

  function setLocalQty(root, variantId, qty) {
    const row = root.querySelector(`[data-addon][data-variant-id="${variantId}"]`);
    if (!row) return;

    const input = row.querySelector('.cart-addon__qty-input');
    const minus = row.querySelector('[data-addon-minus]');

    if (input) input.value = String(qty);
    if (minus) minus.disabled = qty <= 0;
  }

  async function update(variantId, nextQty, root) {
    if (lock.get(variantId)) return;
    lock.set(variantId, true);

    try {
      const cart = await fetchCart();
      const key = findLineItemKey(cart, variantId);

      if (nextQty <= 0) {
        if (key) await changeLineItem(key, 0);
        setLocalQty(root, variantId, 0);
      } else {
        if (!key) {
          await addVariant(variantId, 1);
          setLocalQty(root, variantId, 1);
        } else {
          await changeLineItem(key, nextQty);
          setLocalQty(root, variantId, nextQty);
        }
      }

      // ✅ só isto: avisar o refresher para atualizar line-items/totals
      document.dispatchEvent(new CustomEvent('cart:addons:updated'));

    } catch (e) {
      console.error('[cart-addons]', e);
    } finally {
      lock.set(variantId, false);
    }
  }

  document.addEventListener('click', async (e) => {
    const root = document.querySelector('[data-cart-addons]');
    if (!root) return;

    const row = e.target.closest('[data-addon]');
    if (!row) return;

    const variantId = row.getAttribute('data-variant-id');
    const input = row.querySelector('.cart-addon__qty-input');
    const currentQty = input ? Number(input.value || 0) : 0;

    if (e.target.closest('[data-addon-plus]')) {
      e.preventDefault();
      await update(variantId, currentQty + 1, root);
      return;
    }

    if (e.target.closest('[data-addon-minus]')) {
      e.preventDefault();
      await update(variantId, currentQty - 1, root);
      return;
    }
  }, { passive: false });
})();
